import { useEffect } from "react";
import { useSetLocale } from "react-admin";
import { useTranslation } from "react-i18next";

const LocaleSyncer = () => {
  const setLocale = useSetLocale();
  const { i18n } = useTranslation();

  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      const raLocale = lng.startsWith("fr") ? "fr" : "en";
      setLocale(raLocale);
    };

    // Sync on mount
    const currentLng = i18n.language || "fr";
    handleLanguageChanged(currentLng);

    i18n.on("languageChanged", handleLanguageChanged);
    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, [i18n, setLocale]);

  return null;
};

export default LocaleSyncer;
